import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReview: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReview"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM13.3225 10.1797L12 7.5L10.6775 10.1797L7.72025 10.6094L9.86012 12.6953L9.35497 15.6406L12 14.25L14.645 15.6406L14.1399 12.6953L16.2798 10.6094L13.3225 10.1797Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReview;
